module.exports = __webpack_public_path__ + "assets/img/dca568e90ca42a1be8257836c2c8fa05.png";